<template>
  <v-app>
    <v-app-bar
      app
      color="white"
      height="100"
    >
      

      <v-toolbar-title class="d-none d-md-flex">
        <v-row>
          <v-col cols="12 mb-0 pb-0">
            <h2 class="font-weight-black">CIRCUITO DE PALESTRAS DE COMPUTAÇÃO</h2>
          </v-col>
          <v-col cols="12 pt-0 mt-0">
            <span class="text-md-subtitle-1 font-weight-bold"> IFRS - IBIRUBÁ/RS - 20 a 24/07/2020 e 27 a 31/07/2020</span>
          </v-col>
        </v-row>
         
      </v-toolbar-title>

      <v-toolbar-title class="d-flex d-sm-none d-none d-sm-flex d-md-none font-weight-black text-sm-body-1 headline">
        Circuito de Palestras<br>IFRS - Ibirubá
      </v-toolbar-title>
    
    
    
    </v-app-bar>

    <v-main>
      
      <v-sheet
        id="contact"
        color="#333333"
        dark
        tag="section"
        tile
      >
        <div class="py-12"></div>

        <v-container>
          <v-responsive class="mx-auto mb-12">
            <h4 class="text-md-h4 text-sm-body-2 text-lg-h4 font-weight-bold mb-3 text-uppercase text-center">Usuários Certificados</h4>
            <h5 class="text-center">Dados para serem exportados no formato CSV</h5>
          </v-responsive>

          <v-responsive
            class="mx-auto mb-12"
            width="56"
          >
            <v-divider class="mb-1"></v-divider>

            <v-divider></v-divider>
          </v-responsive>

        
        <v-row> 
            <v-col cols="12">
              <v-list>
                <v-item>NOME,CPF,E-MAIL</v-item>
                <v-list-item v-for="usuario of usuariosCertificados" :key="usuario.email">{{usuario.nome}},{{usuario.cpf}},{{usuario.email}}</v-list-item>
              </v-list>
            </v-col>
        </v-row> 
        
        </v-container>

        <div class="py-12"></div>
      </v-sheet>
    </v-main>

    <v-footer
      class="justify-center"
      color="#292929"
      height="100"
    >
      <div class="title font-weight-light grey--text text--lighten-1 text-center">
        &copy; {{ (new Date()).getFullYear() }} — Computação - IFRS - Ibirubá
      </div>
    </v-footer>
  </v-app>
</template>

<script>
import moment from 'moment'

export default {
  name: 'App',

  data: () => ({
    search: '',
    headers: [
        
        { text: 'Palestra', value: 'palestraTitulo' },
        { text: 'E-mail', value: 'usuarioEmail' },
        { text: 'IP', value: 'usuarioIp' },
        { text: 'Data Assinatura', value: 'dataAssinatura' },
        { text: 'Rating Palestra', value: 'palestraRatingPalestra' },
        { text: 'Rating Transmissão', value: 'palestraRatingTransmissao' },
    ],
    
    presencas: [],
    presencasFiltradas: [],
    comentarios: [],
    usuario: '', 
    usuarios: [],
    usuariosCertificados: [],
  }),

  async created() {
      try{
          this.$http.get('usuarios.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                      var existe = false

                      for(var i=0; i< this.usuarios.length; i++){
                        var usuario = this.usuarios[i]
                        if(usuario.email == value.email){
                          existe = true
                        }
                      }
                      
                      if( existe == false ){
                        this.usuarios.push(
                          {
                              nome: value.nome.toUpperCase(),
                              email: value.email.toLowerCase(),
                              origem: value.origem,
                              cpf: value.cpf,
                              key: key,
                              presencas: [],
                              percentual: '',
                          }
                        )
                      }
  
                    }
                }
            )
            .then( this.ordenarNomes() )
          
          this.$http.get('presenca.json').then(
                res => {
                    for (const [key, value] of Object.entries(res.data)) {
                        this.presencas.push(
                          {
                              usuarioEmail: value.usuarioEmail.toLowerCase(),
                              palestraTitulo: value.palestraTitulo,
                              palestraComentario: value.palestraComentario,
                              dataAssinatura: moment(value.dataAssinatura).format('DD/MM/YYYY hh:mm:ss'),
                              palestraRatingPalestra: value.palestraRatingPalestra,
                              palestraRatingTransmissao: value.palestraRatingTransmissao,
                              palestraRatingDuracao: value.palestraRatingDuracao,
                              palestraId: value.palestraId,
                              usuarioIp: value.usuarioIp,
                              key: key,
                          }
                        )
                    }
                }
           )
           .then( () => {
                    this.gerarRelatorio3()
                }
           )
      }catch(e){
          console.log("Houve erro: " + e)
      }
  },

  methods: {
    selecionaPalestra(){
          console.log("Palestra selecionada: " + this.palestra)
          let teste = this.presencas.filter( (presenca) => {
              return presenca.palestraId == this.palestra
          })
          this.presencasFiltradas = teste
    },

    gerarRelatorio(){
        console.log('gerar relatorio chamado')
        console.log("usuarios length: " + this.usuarios.length)
        console.log("presencas length: " + this.presencas.length)
        var presencasDoUsuario = []

        this.usuarios.forEach(function(usuario){
            console.log("usuario: " + usuario.nome + " email: " + usuario.email)
            presencasDoUsuario = []
            presencasDoUsuario = this.presencas.filter( (presenca) => {
                return presenca.usuarioEmail === usuario.email
            })
            console.log("total: " + presencasDoUsuario.length)
            if( presencasDoUsuario.length > 0){
                presencasDoUsuario.forEach(function(umaPresenca){
                    console.log("Presença: " + umaPresenca.dataAssinatura + " " + umaPresenca.palestraTitulo)
                })
            }
        })
    },

    gerarRelatorio2(){        
        console.log("gerar relatorio - usuarios: " + this.usuarios.length + " presencas: " + this.presencas.length)
        for(var i=0; i< this.usuarios.length; i++){
            let usuario = this.usuarios[i]
            console.log("Usuario: " + usuario.nome + " " + usuario.email)
            for(var j=0; j< this.presencas.length; j++){
              let presenca = this.presencas[j]
              if(usuario.email == presenca.usuarioEmail){
                  console.log("presença: " + presenca.dataAssinatura + " " + presenca.palestraTitulo)
              }  
            }
        }
    },

    gerarRelatorio3(){
        console.log("gerar relatorio - usuarios: " + this.usuarios.length + " presencas: " + this.presencas.length)
        for(var i=0; i< this.usuarios.length; i++){
            let usuario = this.usuarios[i]
            console.log("Usuario: " + usuario.nome + " " + usuario.email)
            
            for(var j=0; j< this.presencas.length; j++){
              let presenca = this.presencas[j]
              if(usuario.email == presenca.usuarioEmail && !(this.usuarios[i].presencas.some(pre => pre.palestraTitulo === presenca.palestraTitulo) )){
                  console.log("presença: " + presenca.dataAssinatura + " " + presenca.palestraTitulo)
                  this.usuarios[i].presencas.push(presenca)
              }  
            }
            this.usuarios[i].percentual = this.usuarios[i].presencas.length*100/10

            if(this.usuarios[i].percentual >= 70){
              this.usuariosCertificados.push(this.usuarios[i])
            }
        }
    },

    ordenarNomes(){
        this.usuarios.sort(function(a, b){
            var nameA=a.nome.toLowerCase(), nameB=b.nome.toLowerCase()
            if (nameA < nameB) //sort string ascending
                return -1 
            if (nameA > nameB)
                return 1
                return 0 //default return value (no sorting)
            })
    }

  }
};
</script>
